import React from 'react';
import { Outlet } from 'react-router-dom';

const WirelineEngagements = () => (
  <Outlet />
);

export default WirelineEngagements;
